import React from 'react'

const RedesSociales = () => {

    return (
        <div className="redes-sociales">
            <a href="https://www.instagram.com/cabo.marques/" target="_blank" rel="nofollow">
                <img alt="" src="/images/instagram.jpg"/>
            </a>
            <a href="https://www.facebook.com/Cabo.Marques.Acapulco" target="_blank" rel="nofollow">
                <img alt="" src="/images/facebook.jpg"/>
            </a>
            <a href="https://www.linkedin.com/company/cabo-marqués/" target="_blank" rel="nofollow">
                <img alt="" src="/images/linkedin.jpg"/>
            </a>
                
        </div>
    )
}

export default RedesSociales